import { ScaffoldSelection } from "../../interface";

/**
 * Returns whether a column is present in the selectedCols list.
 *
 * @param selection - The current scaffold selection state.
 * @param colId - The column ID to check.
 * @returns True if the column is selected.
 */
export const isColInSelection = (selection: ScaffoldSelection, colId: string): boolean =>
  selection.selectedCols.some((c) => c.firstCellId === colId);
